module.exports = __webpack_public_path__ + "img/8-min.2c727fac.jpg";